(function() {
    'use strict';
    class ProductDropdownCleaner {
        constructor() {
            this.init();
        }

        init() {
            // Only run on product pages
            if (!this.isProductPage()) return;

            // Only run on mobile screens (less than 551px)
            if (window.innerWidth >= 551) return;
            console.log("is mobile new");
            this.getTheBurnTime();

            // Check if dropdown elements exist
            if (!this.hasDropdownElements()) return;
            console.log("has dropdown elements")

            // Wait for DOM to be ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => {
                    this.removeCommonEndText();
                    this.handleQuantitySelector();
                    this.getTheBurnTime();
                });
            } else {
                this.removeCommonEndText();
                console.log("remove common end text")
                this.handleQuantitySelector();

            }

            // Also run when new content is loaded (for dynamic content)
            this.observeForNewContent();

            // Listen for window resize to handle orientation changes
            this.handleResize();

            // Optional: Listen for custom events
            this.listenForCustomEvents();
        }

        handleQuantitySelector() {
            // Only run on mobile screens (less than 551px)
            if (window.innerWidth >= 551) return;

            const mobileQuantitySelector = document.getElementById('mobile-quantity-selector');
            const desktopQuantitySelector = document.getElementById('desktop-quantity-selector');
            const productDropdown = document.querySelector('.product-dropdown.js-product-dropdown');

            if (!mobileQuantitySelector || !desktopQuantitySelector || !productDropdown) return;

            // Hide desktop quantity selector on mobile
            desktopQuantitySelector.style.display = 'none';

            // Show mobile quantity selector
            mobileQuantitySelector.style.display = 'block';

            // Move mobile quantity selector after product dropdown
            productDropdown.parentNode.insertBefore(mobileQuantitySelector, productDropdown.nextSibling);
        }

        restoreQuantitySelector() {
            // Only run on desktop screens (551px and above)
            if (window.innerWidth < 551) return;

            const mobileQuantitySelector = document.getElementById('mobile-quantity-selector');
            const desktopQuantitySelector = document.getElementById('desktop-quantity-selector');

            if (!mobileQuantitySelector || !desktopQuantitySelector) return;

            // Hide mobile quantity selector on desktop
            mobileQuantitySelector.style.display = 'none';

            // Show desktop quantity selector
            desktopQuantitySelector.style.display = 'block';
        }

        hasDropdownElements() {
            const dropdownElements = document.querySelectorAll(
                '.product-dropdown.js-product-dropdown a, .product-dropdown.js-product-dropdown .product-dropdown__body span'
            );
            return dropdownElements.length > 0;
        }

        isProductPage() {
            // Check if we're on a product page
            return (
                // Check URL path
                window.location.pathname.includes('/products/') ||
                // Check for product template
                document.body.classList.contains('template-product') ||
                // Check for product-specific elements
                document.querySelector('.product-form, .product-gallery, .product-info') !== null ||
                // Check for Shopify product object
                typeof window.Shopify !== 'undefined' && window.Shopify.theme_name &&
                document.querySelector('[data-product-id], [data-product-handle]') !== null
            );
        }

        listenForCustomEvents() {
            // Listen for custom event to trigger the function
            document.addEventListener('productDropdownClean', () => {
                this.removeCommonEndText();
                this.handleQuantitySelector();
            });

            // Listen for AJAX completion (if using jQuery)
            if (typeof $ !== 'undefined') {
                $(document).on('ajaxComplete', () => {
                    this.removeCommonEndText();
                    this.handleQuantitySelector();
                });
            }
        }

        removeCommonEndText() {
            // Only run on product pages
            if (!this.isProductPage()) return;

            // Only run on mobile screens (less than 551px)
            if (window.innerWidth >= 551) return;

            // Check if dropdown elements exist
            if (!this.hasDropdownElements()) return;

            // Get all dropdown elements (both anchors and spans)
            const dropdownElements = document.querySelectorAll(
                '.product-dropdown.js-product-dropdown a, .product-dropdown.js-product-dropdown .product-dropdown__body span'
            );

            // Get all text content into arrays of words
            const textsArray = Array.from(dropdownElements)
                .map(element => element.textContent?.trim().split(/\s+/))
                .filter((words) => Array.isArray(words) && words.length > 0);

            console.log("Texts Array:", textsArray);

            if (!textsArray.length) return;

            // Find the most common ending among all texts
            const commonEnding = this.findMostCommonEnding(textsArray);
            console.log("Common Ending Found:", commonEnding);

            // If we found a common ending, update the elements
            if (commonEnding) {
                dropdownElements.forEach(element => {
                    const text = element.textContent?.trim();
                    if (text?.endsWith(commonEnding)) {
                        const newText = text.slice(0, -commonEnding.length).trim();
                        element.textContent = newText;
                        element.setAttribute("data-val", newText);
                        // Store original text for restoration
                        element.setAttribute("data-original-text", text);
                    }
                });
            }
        }

        restoreOriginalText() {
            // Only run on desktop screens (551px and above)
            if (window.innerWidth < 551) return;

            // Check if dropdown elements exist
            if (!this.hasDropdownElements()) return;

            const dropdownElements = document.querySelectorAll(
                '.product-dropdown.js-product-dropdown a, .product-dropdown.js-product-dropdown .product-dropdown__body span'
            );

            dropdownElements.forEach(element => {
                const originalText = element.getAttribute("data-original-text");
                if (originalText) {
                    element.textContent = originalText;
                    element.removeAttribute("data-original-text");
                }
            });
        }

        findMostCommonEnding(texts) {
            const endings = {};
            const threshold = Math.max(2, Math.floor(texts.length * 0.5)); // At least 2 texts or 50% must share the ending

            // Try different lengths of endings
            texts.forEach(words => {
                for (let i = 1; i <= words.length; i++) {
                    const ending = words.slice(-i).join(' ');
                    endings[ending] = (endings[ending] || 0) + 1;
                }
            });

            // Find the longest ending that appears in at least threshold number of texts
            return Object.entries(endings)
                .filter(([_, count]) => count >= threshold)
                .sort((a, b) => {
                    // Sort by length (descending) and then by frequency (descending)
                    const lengthDiff = b[0].length - a[0].length;
                    return lengthDiff !== 0 ? lengthDiff : b[1] - a[1];
                })[0]?.[0] || '';
        }

        observeForNewContent() {
            // Only observe on product pages
            if (!this.isProductPage()) return;

            // Only observe on mobile screens
            if (window.innerWidth >= 551) return;

            // Check if dropdown elements exist
            if (!this.hasDropdownElements()) return;

            // Create a MutationObserver to watch for new dropdown content
            const observer = new MutationObserver((mutations) => {
                let shouldRun = false;
                let isQuickBuyModal = false;

                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                                if (node.classList?.contains('product-dropdown') ||
                                    node.querySelector?.('.product-dropdown')) {
                                    shouldRun = true;
                                    
                                    // Check if dropdown is in quick-buy-modal__content
                                    if (node.closest?.('.quick-buy-modal__content') ||
                                        node.querySelector?.('.quick-buy-modal__content')) {
                                        isQuickBuyModal = true;
                                    }
                                }
                            }
                        });
                    }
                });

                if (shouldRun) {
                    // Small delay to ensure all content is loaded
                    setTimeout(() => {
                        if (isQuickBuyModal) {
                            // Restore original text in quick-buy modal
                            this.restoreOriginalText();
                        } else {
                            // Clean text for regular product page
                            this.removeCommonEndText();
                            this.handleQuantitySelector();
                        }
                    }, 100);
                }
            });

            // Start observing
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        handleResize() {
            let isMobile = window.innerWidth < 551;

            window.addEventListener('resize', () => {
                const newIsMobile = window.innerWidth < 551;

                // Only run if switching between mobile and desktop
                if (isMobile !== newIsMobile) {
                    isMobile = newIsMobile;

                    if (isMobile) {
                        // Switched to mobile - run the cleaner and handle quantity selector
                        this.removeCommonEndText();
                        this.handleQuantitySelector();
                        this.getTheBurnTime();
                    } else {
                        // Switched to desktop - restore original text and quantity selector
                        this.restoreOriginalText();
                        this.restoreQuantitySelector();
                    }
                }
            });
        }

        getTheBurnTime() {
            // Only run on mobile
            console.log("burnTimeFunction")
            if (window.innerWidth >= 551) return;

            const target = document.querySelector("details .accordion__content.prose p span");
            const _location = location.pathname.trim().toLowerCase();
            const isDiffuserPage = _location.includes("diffuser");

            if (!target) return;

            const innerText = target.innerText || target.textContent;
            console.log("burnTimeFunction-------------------------------------")
            console.log("Inner Text:", innerText);
            if (!innerText && !document.body.classList.contains("_no_by=burn_time")) {
                document.body.classList.add("no_burn_time");
            }else if (innerText && document.body.classList.contains("no_burn_time")) {
                document.body.classList.remove("no_burn_time");
            }
            if (!innerText) return;
            let burnTime = ""; // Default value
            const trimmedText = innerText.trim().toLowerCase();
            if (!trimmedText) return;
            const isBurnTimeText = trimmedText.includes("burn time");


            if (isBurnTimeText && !isDiffuserPage) {
                console.log("is burn time text");
                // Extract burn time using regex for better reliability

                const text = innerText.trim()?.split("time:")[1];
                if(!text) return;
                const text2 = text.includes("hours") ? text.split("hours")[0] : null;
                if(!text2) return;

                if (text2) {
                    burnTime = `${text2} hr<br> Burn Time`;
                }
            }

            // Find USP 1 element and update it
            const firstUSP = document.querySelector('#PDP_usps .PDP_usps_item:first-child .PDP_ups_item_text');

            if(firstUSP){
                firstUSP.innerHTML = burnTime;
                console.log("Updated USP 1 text to:", burnTime);
            }

        }
    }

    // Initialize when the script loads
    window.productDropdownCleaner = new ProductDropdownCleaner();
})();